import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";
import WSTextField from "../../../../Components/TextBox/WSTextBox";
import { WSTabs } from "../../../../Components/Tabs/WSTabs";
import { Address } from "./Address";
import { Numbering } from "./Numbering";
import { Others } from "./OthersOption";
import { VoucherPrintSettings } from "./Print";


interface StoreProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
}

const Store: React.FC<StoreProps> = ({ control, register }) => {
    const tabsData: any[] = [
        { label: 'Address', content:<Address/> },
        { label: 'Numbering', content:<Numbering/>},
        { label: 'Others', content:<Others/>},
        { label: 'Print', content:<VoucherPrintSettings/>},

      ];
  return (
    <div
      style={{
        position: "relative",
        margin: "auto",
        marginTop: "4rem",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <WSTextField
            control={control}
            id="alias"
            {...register("alias")}
            rules={{ required: true }}
            name="alias"
            label="Alias"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            control={control}
            id="name"
            {...register("name")}
            rules={{ required: false }}
            name="name"
            label="Name"
            labelType="Normal"
          />
        </Grid>
       <Grid item xs={12}>
       <WSTabs id="tabs" control={control} name="tabs" tabs={tabsData} />

       </Grid>
        {/* <Grid item xs={12}>
          <WSSelectField
            options={config.userroleconfig.staticOptionData}
            rules={{ required: true }}
            {...register("userrole")}
            id="userrole"
            control={control}
            label="User Role"
            name="userrole"
            labelType="Normal"
          />
        </Grid> */}
      </Grid>
    </div>
  );
};
export default Store;
